import type {FunctionComponent} from 'react';
import {useMemo} from 'react';
import {useTranslation} from '@app/hooks/use-translation';

import {LandingSection} from '@tempo/landing';
import type {Article} from '@app/components/faq';
import {LandingSeoFaq} from '@app/components/faq';

export const FAQ: FunctionComponent = () => {
	const {t} = useTranslation({ns: ['hifi', 'common']});
	const numberTitle = 90;

	const articles = useMemo<Article[]>(
		() => [
			{
				title: t('deezerhififaq_text_Qhowmanytracksonhifi_web'),
				answer: [
					t('deezerhififaq_text_Ahowmanytracksonhifi_web', {
						count: numberTitle,
						sprintf: [numberTitle],
					}),
				],
			},
			{
				title: t('deezerhififaq_text_Qlistentohififromanyapp_web'),
				answer: [t('deezerhififaq_text_Alistentohififromanyapp_web')],
			},
		],
		[t],
	);
	return (
		<LandingSection data-testid="hifi-faq-section" isContained>
			<LandingSeoFaq articles={articles} />
		</LandingSection>
	);
};
